import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const cppGenerator: LanguageGenerator = {
  id: 'cpp',
  name: 'C++',
  category: 'request-examples',
  color: '#00599C',
  generate(config: ExportConfig): GeneratedFile[] {
    const templateBlocks = config.apps
      .flatMap((a) =>
        a.templates.map((t) => {
          const exampleData = t.schema
            ? JSON.stringify(t.schema.reduce<Record<string, unknown>>((acc, f) => {
                acc[f.key] = f.type === 'number' ? Number(f.example || 0) : f.type === 'boolean' ? true : (f.example || f.key);
                return acc;
              }, {}))
            : '{}';
          return [
            `    // Send: ${t.name}`,
            `    {`,
            `        httplib::Client cli(service_url);`,
            `        cli.set_default_headers({{ "X-API-KEY", ${a.key}_key }});`,
            `        std::string body = R"({"template_slug":"${t.slug}","recipient":"user@example.com","data":${exampleData}})";`,
            `        auto res = cli.Post("/v1/send", body, "application/json");`,
            `        if (res) std::cout << res->body << "\\n";`,
            `    }`,
          ].join('\n');
        }),
      )
      .join('\n\n');

    const keyDecls = config.apps
      .map((a) => `    const char *${a.key}_key = std::getenv("${a.envVarName}");`)
      .join('\n');

    const content = `// mail_requests.cpp — generated by Mail Service SDK Export
// Requires: cpp-httplib (https://github.com/yhirose/cpp-httplib)
// Compile: g++ -std=c++17 mail_requests.cpp -o mail_requests
#include <iostream>
#include <cstdlib>
#include "httplib.h"

int main() {
    const char *service_url = std::getenv("${config.serviceUrlVarName}");
${keyDecls}

${templateBlocks}

    return 0;
}
`;

    return [
      { filename: 'mail_requests.cpp', content, syntax: 'cpp' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
